export const environment = {
  production: true,
  authority: 'https://auth.cam.ngo',
  clientId: 'time-clock',
  apiResource: 'time-clock',
};
